import React, { useEffect, useState } from "react";
import Button from "../../Button";
import apiInstance from "../../apiInstance";
import { useSelector } from "react-redux";

const ChangePaymentMethod = ({ 
    data,
    updateError,
    closePopup,
    updateSubscription
 }) => {

    const {subscriptionId} = data;
    const user = useSelector((state) => state.currentUser);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [selectedCard, setSelectedCard] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        
        setLoading(true);
        updateError("");

        if(!selectedCard) {
            setLoading(false);
            updateError("Please select a payment method to proceed");
            return;
        }

        const apiCall = apiInstance.put(`/dashboard/subscription/${subscriptionId}/update-payment-method`, {
            paymentMethodId: selectedCard
        })

        apiCall
            .then((response) => {
                const returnedSub = response.data.subscription;
                updateSubscription(returnedSub);
                closePopup();
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                console.error("Unexpected error:", error);
                if (error.response) {
                    updateError(error.response.data?.message || 'Something went wrong, please try again later');
                }
            })
    };

    useEffect(() => {
        const fetchUserPaymentMethods = async () => {
            apiInstance
                .get(`/dashboard/payment-method`, {
                    params: {
                        userId: user.id
                    }
                })
                .then((response) => {
                    const fetchedPaymentMethods = response.data.paymentMethods || [];
                    setPaymentMethods(fetchedPaymentMethods);
                    
                })
                .catch((error) => {
                    console.error("Error fetching data:", error);
                    updateError("Failed to load payment methods.");
                });
        }

        fetchUserPaymentMethods();

    }, [user.id]);

    return (
        <div className="mjs-pp">
            <h2>Choose a payment method</h2>
            <form>

                {paymentMethods?.length > 0
                    ? (<div className="mjs-input-field">
                        <p className="mjs-message mjs_text_grey">Updating the payment method here will apply only to this subscription. Any outstanding or failed payment attempts associated with this subscription will be retried using the selected payment method.</p>
                        <select
                            name="selectedCard"
                            value={selectedCard}
                            onChange={(e) => setSelectedCard(e.target.value)}
                        >
                            <option value="">Select Card</option>
                            {paymentMethods.map((pm) => (
                                <option key={pm._id} value={pm._id}>
                                    {pm.detail}
                                </option>
                            ))}
                        </select>
                    </div>)
                    : ("No payment methods found. Please add one to continue.")
                }

            </form>

            <div className="mjs-form-actions">
                {loading && (
                    <i
                        className="fa-solid fa-spinner fa-spin"
                    ></i>
                )}
                <Button
                    name="Save"
                    eventHandler={handleSubmit}
                />
                <Button name="Cancel" eventHandler={closePopup} />
            </div>
        </div>
    );
};

export default ChangePaymentMethod;
